var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrevOutlined = function SvgPrevOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.5 22.664c6.04 0 10.938-4.718 10.938-10.537S18.54 1.59 12.5 1.59c-6.04 0-10.937 4.717-10.937 10.537S6.459 22.664 12.5 22.664m0 1.505c6.904 0 12.5-5.391 12.5-12.042S19.404.084 12.5.084 0 5.476 0 12.127s5.596 12.042 12.5 12.042",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m14.868 8.907-.98-1.152-4.166 4.903 4.167 4.904.979-1.152-3.18-3.752z"
  })));
};
export default SvgPrevOutlined;